import styled from "styled-components";
import {Descriptions, Avatar, Button, Tag, Table, Typography, List, Select, Row} from "antd";
import {MinusCircleFilled, FileImageFilled} from "@ant-design/icons";

const {Text} = Typography;

export const DescriptionContainer = styled(Descriptions)`
    margin-top: 20px;
    margin-bottom: 20px;
`;

export const OrderNumber = styled(Text)`
    font-weight: bold;
`;

export const MergedOrderStats = styled(Text)`
    font-weight: bold;
    float: left;
`;

export const OrderTotalTime = styled(Text)`
    font-weight: bold;
    float: right;
`;

export const TransferInfoContainer = styled.div`
    padding: 0 35px 35px;
    margin-top: 5px;
    margin-bottom: 20px;
    border: 1px solid #f0f0f0;
`;

export const TransferLogList = styled(List)`
    .ant-list-item {
        padding: 6px 0;
    }
    .ant-list-item-meta-title {
        margin-bottom: 0px;
        font-weight: 300;
    }
    .ant-list-item-meta {
        margin-bottom: 0px;
    }
`;

export const TransferDescription = styled.p`
    font-size: 12px;
    color: black;
`;

export const StepContainer = styled.div`
    position: relative;
    padding: 0 35px 35px;
    border: 1px solid #f0f0f0;
    margin-bottom: 30px;
    margin-top: 5px;
    .ant-steps-item-content {
        width: auto;
    }
`;

export const MapContainer = styled.div`
    width: 100%;
    height: 350px;
    overflow: auto;
    border: 5px solid #aeff01;

    z-index: 1;
    position: relative;
    /*            ^^ */
    ${({mode}) =>
        mode == "fixed" &&
        `position:fixed;
        left: 105px;
        right:25px;
        bottom:40px;
        top:95px;
        width:inherit;
        height:inherit;`}
`;
export const MapTools = styled(Button)`
    width: 32px;
    height: 32px;
    position: absolute;
    z-index: 5;
    background: #fff;
    right: 10px;
    top: 10px;
    box-shadow: rgb(0 0 0 / 30%) 0px 1px 4px -1px;
    border-radius: 2px;
    padding: 0;
    svg {
        width: 1.5em;
        height: 1.5em;
        margin: 5px;
    }
`;

export const Marker = styled(Avatar)`
    position: absolute;
    background-color: ${props => props.color};
    transform: translate(-50%, -50%);
    border: 1px solid #021529;
    box-sizing: content-box;
    color: #021529;
    z-index: ${props => (props.$hover ? 2 : 1)};
    font-size: 14px !important;
    border-radius: ${props => props.$hover && "4px"};
    width: ${props => props.$hover && "auto"} !important;
    &:after {
        content: ${props => props.$hover && `"${props.text}"`};
        margin-left: 5px;
    }
    padding: ${props => props.$hover && "5px"} !important;
    transition: border-radius 0.1s;
`;

export const TableTitle = styled.h3`
    margin: 15px 0%;
    font-size: 1.17em !important;
`;

export const TableOverflow = styled.div`
    width: 100%;
    overflow: auto;
`;
export const LeftButton = styled(Button)`
    padding-right: 50px;
    padding-left: 50px;
`;
export const MiddleButton = styled(Button)`
    margin-right: 20px;
    margin-left: 20px;
`;
export const RightButton = styled(Button)`
    float: right;
`;

export const AnnulmentButton = styled(Button)`
    display: ${props => (props.visible === "true" ? "none" : "block")};
    margin: auto;
    width: 90px;
`;
export const PassButton = styled(Button)`
    margin-top: 3px;
    margin-bottom: 10px;
    width: 90px;
`;

export const DetailTag = styled(Tag)`
    margin-bottom: 0.5rem;
    margin-left: 5px;
`;

export const SpinnerContainer = styled.div`
    position: absolute;
    width: calc(100% - 70px);
    height: calc(100% - 70px);
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ffffffbf;
    z-index: 999;
`;

export const OrderTable = styled(Table)`
    .ant-table-tbody > tr.ant-table-row:hover > td {
        background: unset;
    }
`;

export const CancelButton = styled(Button)`
    margin-left: 8px;
`;

export const QueueModalContainer = styled.div`
    width: 600px;
    background-color: white;
`;

export const PrepModalContainer = styled.div`
    width: 600px;
    background-color: white;
`;

export const MinusCircleFilledIcon = styled(MinusCircleFilled)`
    font-size: 20px;
    padding: 5px;
    color: ${props => props.color};
`;

export const FileImageFilledIcon = styled(FileImageFilled)`
    font-size: 20px;
    padding: 5px;
    color: ${props => props.color};
`;

export const SelectField = styled(Select)`
    width: 100%;
`;

export const PrepDetailContainer = styled.div`
    margin-top: 20px;
    margin-bottom: 20px;
`;

export const MapStepRow = styled(Row)`
    @media screen and (max-width: 992px) {
        flex-direction: column-reverse;
    }
`;
